const scale = 2;
const eye1 = {
    center: { x: 71.2405 * scale, y: 39.3549 * scale },
    line: {
        p1: { x: 32.2 * scale, y: 53 * scale },
        p2: { x: 110.2 * scale, y: 53 * scale }
    },
    curves: [{
            p1: { x: 32.2 * scale, y: 53 * scale },
            cp1: { x: 34.800000000000004 * scale, y: 47.8 * scale },
            cp2: { x: 37.800000000000004 * scale, y: 43.9 * scale },
            p2: { x: 40.400000000000006 * scale, y: 41.1 * scale }
        },
        {
            p1: { x: 40.400000000000006 * scale, y: 41. * scale },
            cp1: { x: 49.00000000000001 * scale, y: 31.400000000000002 * scale },
            cp2: { x: 60.7 * scale, y: 25.900000000000002 * scale },
            p2: { x: 73 * scale, y: 25.900000000000002 * scale }
        },
        {
            p1: { x: 73 * scale, y: 25.900000000000002 * scale },
            cp1: { x: 84.8 * scale, y: 25.900000000000002 * scale },
            cp2: { x: 94.6 * scale, y: 29.6 * scale },
            p2: { x: 101.3 * scale, y: 36.7 * scale }
        },
        {
            p1: { x: 101.3 * scale, y: 36.7 * scale },
            cp1: { x: 105.5 * scale, y: 41.1 * scale },
            cp2: { x: 108.5 * scale, y: 46.6 * scale },
            p2: { x: 110.2 * scale, y: 53 * scale }
        }]
};
const eye2 = {
    center: { x: 241.4697 * scale, y: 39.3549 * scale },
    line: {
        p1: { x: 199.6 * scale, y: 55 * scale },
        p2: { x: 283.4 * scale, y: 55 * scale }
    },
    curves: [{
            p1: { x: 199.6 * scale, y: 55 * scale },
            cp1: { x: 202.5 * scale, y: 48.2 * scale },
            cp2: { x: 206.29999999999998 * scale, y: 43.1 * scale },
            p2: { x: 209.5 * scale, y: 39.7 * scale }
        },
        {
            p1: { x: 209.5 * scale, y: 39.7 * scale },
            cp1: { x: 218.5 * scale, y: 29.6 * scale },
            cp2: { x: 230.7 * scale, y: 23.900000000000002 * scale },
            p2: { x: 243.6 * scale, y: 23.900000000000002 * scale }
        },
        {
            p1: { x: 243.6 * scale, y: 23.900000000000002 * scale },
            cp1: { x: 255.9 * scale, y: 23.900000000000002 * scale },
            cp2: { x: 266.2 * scale, y: 27.8 * scale },
            p2: { x: 273.4 * scale, y: 35.300000000000004 * scale }
        },
        {
            p1: { x: 273.4 * scale, y: 35.300000000000004 * scale },
            cp1: { x: 278.4 * scale, y: 40.50000000000001 * scale },
            cp2: { x: 281.79999999999995 * scale, y: 47.2 * scale },
            p2: { x: 283.4 * scale, y: 55 * scale }
        }]
};
const eye3 = {
    center: { x: 412.3119 * scale, y: 39.3549 * scale },
    line: {
        p1: { x: 377.8 * scale, y: 50.1 * scale },
        p2: { x: 447.2 * scale, y: 50.1 * scale }
    },
    curves: [{
            p1: { x: 377.8 * scale, y: 50.1 * scale },
            cp1: { x: 379.6 * scale, y: 47.2 * scale },
            cp2: { x: 381.5 * scale, y: 44.9 * scale },
            p2: { x: 383.2 * scale, y: 43 * scale }
        },
        {
            p1: { x: 383.2 * scale, y: 43 * scale },
            cp1: { x: 388.9 * scale, y: 36.5 * scale },
            cp2: { x: 399 * scale, y: 28.7 * scale },
            p2: { x: 413.8 * scale, y: 28.7 * scale }
        },
        {
            p1: { x: 413.8 * scale, y: 28.7 * scale },
            cp1: { x: 432.5 * scale, y: 28.7 * scale },
            cp2: { x: 442.8 * scale, y: 38.3 * scale },
            p2: { x: 447.2 * scale, y: 50.1 * scale }
        }]
};
const eye4 = {
    center: { x: 49.1 * scale, y: 26.3 * scale },
    line: {
        p1: { x: 24.6 * scale, y: 34 * scale },
        p2: { x: 73.6 * scale, y: 34 * scale }
    },
    curves: [{
            p1: { x: 24.6 * scale, y: 34 * scale },
            cp1: { x: 25.8 * scale, y: 32.1 * scale },
            cp2: { x: 27.2 * scale, y: 30.2 * scale },
            p2: { x: 28.8 * scale, y: 28.4 * scale }
        },
        {
            p1: { x: 28.8 * scale, y: 28.4 * scale },
            cp1: { x: 34.9 * scale, y: 21.9 * scale },
            cp2: { x: 42.1 * scale, y: 18.6 * scale },
            p2: { x: 50.2 * scale, y: 18.6 * scale }
        },
        {
            p1: { x: 50.2 * scale, y: 18.6 * scale },
            cp1: { x: 59.7 * scale, y: 18.6 * scale },
            cp2: { x: 69.8 * scale, y: 22.8 * scale },
            p2: { x: 73.6 * scale, y: 34 * scale }
        }]
};
const eye5 = {
    center: { x: 49.1 * scale, y: 148.6 * scale },
    line: {
        p1: { x: 25.7 * scale, y: 155.8 * scale },
        p2: { x: 72.7 * scale, y: 155.8 * scale }
    },
    curves: [{
            p1: { x: 25.7 * scale, y: 155.8 * scale },
            cp1: { x: 26.7 * scale, y: 154.2 * scale },
            cp2: { x: 27.9 * scale, y: 152.7 * scale },
            p2: { x: 29.3 * scale, y: 151.2 * scale }
        },
        {
            p1: { x: 29.3 * scale, y: 151.2 * scale },
            cp1: { x: 35.3 * scale, y: 144.8 * scale },
            cp2: { x: 42.4 * scale, y: 141.6 * scale },
            p2: { x: 50.3 * scale, y: 141.6 * scale }
        },
        {
            p1: { x: 50.3 * scale, y: 141.6 * scale },
            cp1: { x: 62.8 * scale, y: 141.6 * scale },
            cp2: { x: 69.7 * scale, y: 147.9 * scale },
            p2: { x: 72.7 * scale, y: 155.8 * scale }
        }]
};
const eye6 = {
    center: { x: 49.1 * scale, y: 271.1 * scale },
    line: {
        p1: { x: 22.7 * scale, y: 279.9 * scale },
        p2: { x: 75 * scale, y: 279.9 * scale }
    },
    curves: [{
            p1: { x: 22.7 * scale, y: 279.9 * scale },
            cp1: { x: 24 * scale, y: 277.3 * scale },
            cp2: { x: 25.9 * scale, y: 274.8 * scale },
            p2: { x: 28.1 * scale, y: 272.5 * scale }
        },
        {
            p1: { x: 28.1 * scale, y: 272.5 * scale },
            cp1: { x: 34.4 * scale, y: 265.8 * scale },
            cp2: { x: 41.9 * scale, y: 262.4 * scale },
            p2: { x: 50.3 * scale, y: 262.4 * scale }
        },
        {
            p1: { x: 50.3 * scale, y: 262.4 * scale },
            cp1: { x: 64.8 * scale, y: 262.4 * scale },
            cp2: { x: 72.2 * scale, y: 270.7 * scale },
            p2: { x: 75 * scale, y: 279.9 * scale }
        }]
};
export const eyesLandscape = [eye1, eye2, eye3];
export const eyesPortrait = [eye4, eye5, eye6];
